import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IPartFinderFamily } from 'companySettings/types';
import { Button } from 'core/components';

import { UpsertPartFinderFamily } from './UpsertPartFinderFamily';

interface IProps {
  family?: IPartFinderFamily;
  buttonElement?: ReactElement;
}

export const UpsertPartFinderFamilyButton = ({ family, buttonElement }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={t('buttonLabelAddPartFinderFamily')}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />
    );
  }, [buttonElement, t]);

  return (
    <>
      {button}

      <UpsertPartFinderFamily family={family} isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
